// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__JRGZD","header":"ReportDetails_header__1wkHu","title":"ReportDetails_title__1_DN7","left":"ReportDetails_left__3TWus"};